import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-course-tile',
  templateUrl: './course-tile.component.html',
  styleUrls: ['./course-tile.component.scss']
})
export class CourseTileComponent implements OnInit {
  @Input('course') course;
  @Input('inSlider') inSlider;
  @Input('hidePlaybackBar') hidePlaybackBar:boolean=false;
  public showPlayback:boolean=false;
  public duration:number=0;
  public position:number=0;

  constructor(private router:Router) { }

  calculateProgress(){
    if(this.course.lessons){
      this.course.lessons.forEach(lesson=>{
        this.duration+=lesson.duration;
        if(lesson.meta && lesson.meta[0]){
          if (lesson.meta[0].watched) {
            this.position+=lesson.duration;
          } else {
            this.position+=lesson.meta[0].playback_position;
          }
        }
      });
    }
  }

  ngOnInit() {
    this.calculateProgress();
  }

  redirectTo(uri:string){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then( ()=> this.router.navigate([uri]) );
  }
}
